import type { Variant } from '../utils';

import {
  FloatingGreenIcon,
  FloatingMembershipIcon,
  FloatingOrangeIcon,
  FloatingSolidIcon,
  FloatingStrokeIcon,
  FloatingTransparantIcon,
} from '~/assets/icons/card_banner';

interface PrefixLogo {
  variant: Variant;
}

const iconMap = {
  solid: FloatingSolidIcon,
  stroke: FloatingStrokeIcon,
  membership: FloatingMembershipIcon,
  'solid-green': FloatingTransparantIcon,
  'stroke-green': FloatingGreenIcon,
  'stroke-orange': FloatingOrangeIcon,
  'solid-orange': FloatingTransparantIcon,
};

const PrefixLogo = ({ variant }: PrefixLogo) => {
  const IconComponent = iconMap[variant] || FloatingSolidIcon;

  return <IconComponent />;
};
export default PrefixLogo;
